/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadServiceResourceRegionRequest {
    getFixupPrototypeFunction() { return WorkloadServiceResourceRegionRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkloadServiceResourceRegionRequest>): WorkloadServiceResourceRegionRequest {
        let obj = Object.assign(new WorkloadServiceResourceRegionRequest(), model);
        WorkloadServiceResourceRegionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadServiceResourceRegionRequest>): WorkloadServiceResourceRegionRequest {
        if (!model) return null;
        return WorkloadServiceResourceRegionRequest.newInstance(<WorkloadServiceResourceRegionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadServiceResourceRegionRequest) {
        if (!obj) return;

        models.WorkloadServiceResourceRegionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadServiceResourceRegionRequest): boolean {
        Object.setPrototypeOf(obj, WorkloadServiceResourceRegionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which cloud account ids to fetch regions for
     */
    cloud_account_ids: Array<string>;

}
